import { FC, useMemo, useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import { type FieldErrors } from 'react-hook-form';
import { PasswordFormFieldValues } from './EnterPassword';
import {
  LockOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';

type Props = {
  fieldName: keyof PasswordFormFieldValues;
  errors: FieldErrors<PasswordFormFieldValues>;
  inputProps: Record<string, unknown>;
};

const PasswordField: FC<Props> = ({ fieldName, inputProps, errors }) => {
  const [isVisible, setIsVisible] = useState(false);

  const fieldLabel = useMemo(() => {
    return fieldName === 'password' ? 'Password' : 'Confirm Password';
  }, [fieldName]);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <TextField
      type={isVisible ? 'text' : 'password'}
      slotProps={{
        input: {
          ...inputProps,
          startAdornment: <LockOutlined sx={{ pr: 1 }} />,
          endAdornment: (
            <IconButton onClick={toggleVisibility}>
              {isVisible ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
            </IconButton>
          ),
        },
      }}
      autoFocus={fieldName === 'password'}
      label={fieldLabel}
      fullWidth
      error={Boolean(errors[fieldName])}
    />
  );
};

export default PasswordField;
